import React from 'react';
import './index.scss';

import BasicCheckBoxInput from 'components/atoms/Input/BasicCheckBoxInput';
import CheckBoxInput from 'components/atoms/Input/CheckBoxInput';
import RadioInput from 'components/atoms/Input/RadioInput';
import CalendarInput from 'components/atoms/Input/CalendarInput';
import TextInput from 'components/atoms/Input/TextInput';
import TextAreaInput from 'components/atoms/Input/TextAreaInput';
import SpSkillLevel from 'components/molecules/SpSkillLevel';
import SpAccordionInput from 'components/molecules/SpAccordionInput';
import PcErrorArea from 'components/molecules/PcErrorArea';
import RequiredOrOptionalIcon from 'components/atoms/Icon/RequiredOrOptionalIcon';
import SpPopUp from 'components/molecules/SpPopUp';
import SpHowToDo from 'components/molecules/SpHowToDo';
import SpSuggestList from 'components/molecules/SpSuggestList';

const SpInputTitle = ({
  title,
  label,
  questionMark,
  popUpTitle,
  popUpDetail,
  subTitle,
  list = [],
  type,
  isLine, // 点線が無しの場合はfalseを設定する
  selectedDate,
  errorDispMessages,
  comment,
  radioChild,
  childInput,
}) => {
  const DispTitle = () => {
    return Array.isArray(title)
      ? title.map(line => (
        <span key={line} className="">
          {line}
          <br />
        </span>
      ))
      : <>{title}</>;
  };

  const DispSubTitle = () => {
    return Array.isArray(subTitle)
      ? subTitle.map(line => (
        <span key={line} className="">
          {line}
          <br />
        </span>
      ))
      : <>{subTitle}</>;
  };

  const editPopUpDetail = (popUpLines) => {
    return (
      <span>
      <p>
        {Array.isArray(popUpLines)? popUpLines.map(line => (<span key={line}>{line}<br /></span>)) : <>{popUpLines}</>}
      </p>
    </span>
    )
  };

  return (
    <div className="SpInputTitle">
      <div className="SITM-title">
        <DispTitle />
        {<RequiredOrOptionalIcon label={label} />}
        {questionMark && <SpPopUp title={popUpTitle} children={editPopUpDetail(popUpDetail)}/>}
      </div>

      {subTitle !== null && subTitle !== '' ? <div className="SITM-subTitle"><DispSubTitle /></div>: <></>}

      {type === "TitleOnly" ? <></> :
        <>
          <div className="SITM-item">
            <DispList type={type} list={list} selectedDate={selectedDate} comment={comment} radioChild={radioChild} childInput={childInput} />
          </div>
          <PcErrorArea position='relative' message={errorDispMessages} />
          <>
            {isLine ? <div className="horizontalLine" /> : <div />}
          </>
        </>
      }
    </div>
  );
};

export default SpInputTitle;

const DispList = (prop) => {
  switch (prop.type) {
    case 'CheckBoxInput': return (
      <CheckList list={prop.list} />
    ); break;
    case 'SkillLevel': return (
      <SkillList list={prop.list} />
    ); break;
    case 'BasicCheckBoxInput': return (
      <BasicCheckList list={prop.list} comment={prop.comment}/>
    ); break;
    case 'BasicCheckBoxOnly': return (
      <BasicCheckBoxOnly list={prop.list} comment={prop.comment}/>
    ); break;
    case 'RadioInput': return (
      <RadioInputList list={prop.list} selectedDate={prop.selectedDate} comment={prop.comment}/>
    ); break;
    case 'TextInput': return (
      <TextInputList list={prop.list} />
    ); break;
    case 'TextAreaInput': return (
      <TextAreaInputList list={prop.list} />
    ); break;
    case 'FreeInput': return (
      <FreeInputList list={prop.list} />
    ); break;
    case 'RadioChidInput': return (
      <RadioInputWithRadioChidList list={prop.list} radioChild={prop.radioChild}/>
    ); break;
    case 'CheckBoxChildInput': return (
      <CheckBoxInputWithChildList list={prop.list} childInput={prop.childInput} />
    ); break;
    case 'HowToDo': return (
      <HowToDo list={prop.list} />
    ); break;
    default: return null;
  }
};

const CheckList = ({ list: detail }) => {
  return (
    <div className="">
      {detail.map(data => (
        <span className="" key={data.id}>
          <CheckBoxInput
            id={data.id}
            value={data.value}
            onChange={data.onChange}
            checked={data.checked}
            label={data.label}
          />
        </span>
      ))}
    </div>
  );
};

const SkillList = ({ list: detail }) => {
  return (
    <div className="">
      {detail.map(data => (
        <span className="list" key={data.id}>
          <SpSkillLevel
            id={data.id}
            name={data.name}
            value={data.value}
            onChange={data.onChange}
            checked={data.checked}
            level={data.level}
            salary={data.salary}
            skill={data.skill}
          />
        </span>
      ),
      )}
    </div>
  );
};

const BasicCheckList = ({ list: detail, comment }) => {
  return (
    <div className="">
      {detail.map(data => (
        <span className="SpInputTitle basicCheckbox" style={radioWidth(data.number)} key={data.id}>
          <BasicCheckBoxInput
            id={data.id}
            value={data.value}
            onChange={data.onChange}
            checked={data.checked}
            disabled={data.disabled}
            label={data.label}
          />
        </span>
      ),
      )}
      <div className="commentArea">{comment}</div>
    </div>
  );
};

const BasicCheckBoxOnly = ({ list: data, comment }) => {
  return (
    <div className="">
      <BasicCheckBoxInput
        id={data.id}
        value={data.value}
        onChange={data.onChange}
        disabled={data.disabled}
        checked={data.checked}
        label={data.label}
      />
      <div className="commentArea">{comment}</div>
    </div>
  );
};

const radioWidth = ( pNumber ) => ({
  width: `calc(100% / ${pNumber} - 10px)`,
});

const today = new Date();
const tommorow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);

const RadioInputList = ({ list: detail, selectedDate, comment }) => {
  return (
    <div className="itemArea">
      {detail.map(data => (
        <span className="SpInputTitle radioInput" key={data.id}>
          {
            !data.isCalendarRadio ? (
              <RadioInput
                id={data.id}
                name={data.name}
                value={data.value}
                onChange={data.onChange}
                checked={data.checked}
                label={data.label}
              />
            )
              : (
                <CalendarInput 
                  minDate={tommorow}
                  selected={selectedDate}
                  radioInput={data}
                  label={data.label}
                />
              )
          }
        </span>
      ),
      )}
      <div className="commentArea">{comment}</div>
    </div>
  );
};

const RadioInputWithRadioChidList = ({ list: detail, radioChild }) => {
  return (
    <div className="itemArea">
      {detail.map(data => (
        <span className="SpInputTitle radioInput" key={data.id}>
          <RadioInput
            id={data.id}
            name={data.name}
            value={data.value}
            onChange={data.onChange}
            checked={data.checked}
            label={data.label}
          />
        </span>
      ),
      )}
      {!radioChild ? (<></>) : (
        <>
          <div className="radioChidArea">
            <SpAccordionInput
              title={radioChild.title}
              label={radioChild.label}
              list={radioChild.list}
              type={radioChild.type}
              visible={radioChild.visible}
            />
          </div>
        </>
      )}
    </div>
  );
};
const CheckBoxInputWithChildList = ({ list: detail, childInput }) => {
  return (
    <>
      {detail.map(data => (
        <span className="SpInputTitle basicCheckbox" style={radioWidth(data.number)} key={data.id}>
          <BasicCheckBoxInput
            id={data.id}
            value={data.value}
            onChange={data.onChange}
            checked={data.checked}
            label={data.label}
          />
        </span>
      ),
      )}
      {!childInput ? (<></>) : (
        <>
          <div className="childArea">
            <SpAccordionInput
              title={childInput.title}
              label={childInput.label}
              list={childInput.list}
              type={childInput.type}
              visible={childInput.visible}
            />
          </div>
        </>
      )}
    </>
  );
};


const TextInputList = ({ list: detail }) => {
  return (
    <div className="">
      <span className="SpInputTitle TextInput">
        {detail.map(data => (
          <span key={data.name}>
            <TextInput
              name={data.name}
              val={data.value}
              onChange={data.onChange}
              onInput={data.onInput}
              onCompositionEnd={data.onCompositionEnd}
              maxLength={data.maxLength}
              placeholder={data.placeholder}
              inValid={data.inValid}
            />
            {
              !!data.suggestList ?
                <SpSuggestList
                  items={data.suggestList.items}
                  onClick={data.suggestList.onClick}
                />
                :
                <></>
            }
          </span>
        ))}
      </span>
    </div>
  );
};
const TextAreaInputList = ({ list: detail }) => {
  return (
    <div className="itemArea">
      <span className="SpInputTitle TextAreaInput">
        {detail.map(data => (
          <span key={data.name}>
            <TextAreaInput
              name={data.name}
              value={data.value}
              onChange={data.onChange}
              onInput={data.onInput}
              onCompositionEnd={data.onCompositionEnd}
              maxLength={data.maxLength}
              rows={data.rows}
              cols={data.cols}
              placeholder={data.placeholder}
              inValid={data.inValid}
            />
            <div className='word-count'>{data.wordCount}</div>
          </span>
        ))}
      </span>
    </div>
  );
};
const FreeInputList = ({ list: detail }) => {
  return (
    <div className="">
      {detail}
    </div>
  );
};

const HowToDo = ({ list: detail }) => {
  return (
    <span className="">
      {detail.map(data => (
        <span className="" key={data.id}>
          <SpHowToDo
            value={data.value}
            checked={data.checked}
            label={data.label}
            subLabel={data.subLabel}
            point={data.point}
            icon={data.icon}
            onChange={data.onChange}
            id={data.id}
          />
        </span>
      ))}
    </span>
  );
};